/**
 * Permissions fines (table `permission` / `role_permission`).
 * Regroupées par module pour rester lisibles dans l'écran de gestion des rôles.
 */
export const PERMISSION_CODES = [
    // Back-office / sécurité
    'users.manage',
    'roles.manage',
    'sites.manage',
    'audit.view',
    // Référentiel (lecture seule — synchronisé depuis la CNSS)
    'referentiel.view',
    'testzone.manage',
    // Documents
    'documents.upload',
    'documents.review',
    // Biométrie / ABIS
    'biometrie.capture',
    'abis.review',
    'abis.decide',
    // Carte sociale
    'carte.personnaliser',
    'carte.activer',
    'carte.suspendre',
    'carte.design',
    // Logistique
    'logistique.manage',
    // Remise & contrôle
    'remise.effectuer',
    'controle.effectuer',
    // Reporting
    'reporting.view',
];
//# sourceMappingURL=permissions.js.map